import { useState, useEffect } from "react";
import { CookieConsent, defaultConsent, CONSENT_COOKIE_NAME, getUserLanguage, saveUserLanguage } from "@/lib/i18n";
import { SupportedLanguage } from "@/components/multilingual/LanguageSelector";
import CookieSettingsDialog from "@/components/cookies/CookieSettingsDialog";

export function CookieSettingsLauncher() {
  const [open, setOpen] = useState(false);
  const [language, setLanguage] = useState<SupportedLanguage>(getUserLanguage());
  const [consent, setConsent] = useState<CookieConsent>({ ...defaultConsent });

  useEffect(() => {
    try {
      const savedConsent = localStorage.getItem(CONSENT_COOKIE_NAME);
      if (savedConsent) {
        const parsed = JSON.parse(savedConsent);
        setConsent({ ...defaultConsent, ...parsed });
      }
    } catch (error) {
      // Fallback to default consent
      setConsent({ ...defaultConsent });
    }
  }, []);

  const handleSwitchChange = (category: keyof CookieConsent) => {
    if (category === "necessary") return;
    setConsent((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const handleSave = () => {
    localStorage.setItem(CONSENT_COOKIE_NAME, JSON.stringify(consent));
    setOpen(false);
  };

  const handleLanguageChange = (newLanguage: SupportedLanguage) => {
    setLanguage(newLanguage);
    saveUserLanguage(newLanguage);
  };

  return (
    <>
      <button
        type="button"
        className="hover:text-primary transition-colors"
        onClick={() => setOpen(true)}
      >
        Cookie Settings
      </button>
      <CookieSettingsDialog
        open={open}
        onOpenChange={setOpen}
        language={language}
        consent={consent}
        onSwitchChange={handleSwitchChange}
        onSave={handleSave}
        onClose={() => setOpen(false)}
        onLanguageChange={handleLanguageChange}
      />
    </>
  );
}

export default CookieSettingsLauncher;
